import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

// text-base no celular: fonte menor que 16px em campo focado dispara o auto-zoom do iOS Safari.
export const bareInputCls =
  "w-full border-0 bg-transparent p-0 text-base text-zinc-900 outline-none placeholder:text-zinc-300 focus:outline-none focus:ring-0 sm:text-sm dark:text-foreground";

/** Caixa de campo do diálogo: rótulo pequeno em cima, controle sem borda dentro. */
export function CampoDaConsulta({
  label,
  children,
  action,
  className,
  comoDiv = false,
}: {
  label: string;
  children: ReactNode;
  /** Controle opcional à direita do rótulo (ex: limpar). Fica fora do fluxo do rótulo pra não
   *  roubar o foco do campo ao ser clicado. */
  action?: ReactNode;
  className?: string;
  /** Campo com vários controles (busca, etiquetas, botões): label faria qualquer clique focar o primeiro. */
  comoDiv?: boolean;
}) {
  const Caixa = comoDiv ? "div" : "label";
  return (
    <Caixa
      className={cn(
        "block rounded-lg border border-zinc-200 bg-white px-3 py-2 transition-colors focus-within:border-brand-500 focus-within:ring-1 focus-within:ring-brand-500 hover:border-zinc-300 has-[select:focus]:border-brand-500 has-[select:focus]:ring-1 has-[select:focus]:ring-brand-500 dark:border-border dark:bg-card dark:hover:border-border",
        className,
      )}
    >
      <span className="mb-0.5 flex items-center justify-between gap-2">
        <span className="block text-[10px] font-semibold uppercase tracking-wider text-zinc-500 dark:text-muted-foreground">{label}</span>
        {action}
      </span>
      {children}
    </Caixa>
  );
}
